export class RemoveGroupFromBuildingsDto {
  buildingIds: string[];

  constructor(data: { buildingIds: string[] }) {
    this.buildingIds = data.buildingIds;
  }
}
